import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'; // 引入 Vuex
import VueI18n from 'vue-i18n';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import en from './i18n/en';
import zh from './i18n/zh';
import th from './i18n/th';
import 'animate.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(VueI18n)
Vue.use(AOS.init({
  once: true,        // 动画是否只触发一次
  mirror: false      // 滚动回去时是否重新触发动画
}));
let lang = localStorage.getItem('lang') || 'en'
export const i18n = new VueI18n({
  locale: lang, // 设置默认语言
  messages: {
    en,
    zh,
    th
  },
  fallbackLocale: 'zh'
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
